import type { ReactNode } from 'react';
import { ContentfulLivePreview } from '@contentful/live-preview';
import { ContentfulLivePreviewProvider } from '@contentful/live-preview/react';
import type { ContentfulPageViewModel } from 'autogen/swagger/all';
import PreviewOverlay from 'components/pages/Contentful/components/PreviewOverlay/PreviewOverlay';
import { PreviewProvider } from 'components/pages/Contentful/context/PreviewContext';

export default function Preview({
    model,
    children
}: {
    model: ContentfulPageViewModel['useCaseModel'];
    children: ReactNode;
}) {
    const { contentfulLocale, previewUserType, contentfulPage } = model;

    if (!ContentfulLivePreview.initialized) {
        ContentfulLivePreview.init({
            locale: contentfulLocale
        });
    }

    return (
        <PreviewProvider isPreviewMode={true}>
            <PreviewOverlay userType={previewUserType} slug={contentfulPage.slug} />
            <ContentfulLivePreviewProvider locale={contentfulLocale}>{children}</ContentfulLivePreviewProvider>
        </PreviewProvider>
    );
}
